import { Link } from "react-router-dom";
import { COMPARISON, getProduct } from "@/data/content";
import { ArrowRight } from "lucide-react";

export default function ComparisonTable() {
  return (
    <div data-testid="comparison-table" className="overflow-x-auto rounded-3xl bg-white shadow-[0_10px_40px_-18px_rgba(23,68,94,0.2)]">
      <table className="w-full min-w-[720px] border-collapse text-left">
        <thead>
          <tr className="border-b border-border">
            <th className="p-5 md:p-6 text-xs font-bold uppercase tracking-widest text-muted-foreground">
              Ominaisuus
            </th>
            {COMPARISON.columns.map((c) => (
              <th key={c.slug} className="p-5 md:p-6 align-bottom">
                <span className="font-heading text-base md:text-lg font-semibold leading-tight block">
                  {c.name}
                </span>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {COMPARISON.rows.map((row, i) => (
            <tr key={row.label} className={i % 2 === 0 ? "bg-water-soft/60" : "bg-white"}>
              <td className="p-5 md:p-6 text-sm font-bold text-foreground align-top">{row.label}</td>
              {row.values.map((v, j) => (
                <td key={j} className="p-5 md:p-6 text-sm leading-relaxed text-muted-foreground align-top">
                  {v}
                </td>
              ))}
            </tr>
          ))}
          <tr>
            <td className="p-5 md:p-6" />
            {COMPARISON.columns.map((c) => {
              const p = getProduct(c.slug);
              return (
                <td key={c.slug} className="p-5 md:p-6">
                  <Link
                    to={`/tuote/${c.slug}/`}
                    data-testid={`comparison-buy-${c.slug}`}
                    className="inline-flex h-11 items-center gap-2 rounded-full bg-primary px-5 text-sm font-bold text-primary-foreground transition-transform duration-200 hover:scale-[1.03]"
                  >
                    {p.priceLabel} <ArrowRight size={15} />
                  </Link>
                </td>
              );
            })}
          </tr>
        </tbody>
      </table>
    </div>
  );
}
